import { Metadatum } from '../../types/Metadata';
import { Pill, Icon, enums } from 'edrolo-ui';
import cx from 'classnames';
import s from './styles.scss';

interface Props {
  metadata: Metadatum[];
  className?: string;
}

export const Metadata = ({ className, metadata }: Props) => {
  if (metadata.length === 0) {
    return null;
  }
  return (
    <div className={cx(s.metadata, className)} role="img" aria-label="metadata">
      {metadata.map((metadatum: Metadatum) => {
        return (
          <div key={metadatum.title} className={s.metadatum}>
            <Pill variant={enums.PillVariant.CIRCLE} color={metadatum.color}>
              <Icon name={metadatum.iconName} />
            </Pill>

            <div>
              {metadatum.count ? `${metadatum.count} ` : null}
              {metadatum.title}
            </div>
          </div>
        );
      })}
    </div>
  );
};
